<app-header title="Select Fridge" (back)="back()"></app-header>

<ion-content>
  <app-fridge-picker
    [fridgeList]="fridgeService.fridges"
    (select)="open($event)"
  ></app-fridge-picker>
</ion-content>
